import { dateProvider } from '@utils';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';

import { StepWrapper } from '../../../styles';
import { MessageWrapper } from '../../../styles';
import { TranslatedTitle, TranslatedText } from '../components';

import { NoMarginWrapper } from './StudyPlan.styles';

import { Icon } from '@/components/Icon';
import { OnBoardingWeekDaysPicker } from '@/components/Onboarding';
import { SpecificDaysPicker } from '@/components/Planification';
import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useOnboardingFormLogic } from '@/hooks';

export const StudyPlan = () => {
  const { examGroupDate } = useOnboardingFormLogic();

  const showMessage = !!examGroupDate;
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="STUDY_PLAN" />
      <Box flexDirection="column">
        <Box flexDirection="column" gap={8}>
          <TranslatedText i18nKey="STUDY_PLAN_FINISH_DATE" />
          <NoMarginWrapper $noMargin={showMessage}>
            <Form.Item rules={[RULES.REQUIRED]} name={['planification', 'endDate']}>
              <DatePicker format="DD/MM/YYYY" minDate={dayjs()} />
            </Form.Item>
          </NoMarginWrapper>
          {showMessage && (
            <MessageWrapper>
              <Icon i="Information" color="purple6" />
              <TranslatedText
                i18nKey="STUDY_PLAN_FINISH_DATE_MESSAGE"
                values={{
                  date: dateProvider.format(examGroupDate, 'dd/MM/yyyy')
                }}
              />
            </MessageWrapper>
          )}
        </Box>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="REST_WEEK_DAYS" />
          <Form.Item name={['planification', 'restWeekdays']}>
            <OnBoardingWeekDaysPicker />
          </Form.Item>
        </Box>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="REST_DATES" />
          <Form.Item name={['planification', 'restDates']}>
            <SpecificDaysPicker hideLabel />
          </Form.Item>
        </Box>
      </Box>
    </StepWrapper>
  );
};
